import React, { Component, Fragment } from 'react';
import { Alert, Button, Spinner, Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { groupSurveysByParent } from '../../Utils/groupSurveys';
import { getSurveyDisplayName } from '../../Utils/surveyDisplayName';
import { PageStatus } from 'enums';
import { Show } from "../../Layout";
import CardHeader from "../Card/CardHeader";
import GridContainer from "../Grid/GridContainer";
import moment from "moment/moment";
import { SurveysAPI, MasterDataAPI } from "../../API";
import { exportToExcel } from "../../Utils/ExportToExcel";
import ShowDataAccording2PageSize from '../ShowEntries/ShowEntries';
import PaginationNumbering from '../ShowEntries/Pagination';
import Swal from 'sweetalert2';
import { connect } from 'react-redux';
import LanguageContext from "../../Layout/LanguageContext";
import { pageDict } from "../../Languages/PageTranslations";
import { isPanelCountryByName } from './surveyConstants';
import './redesign/surveys-redesign.css';
import { marketCodes, SUMMARY_COLUMNS, ALL_FIELDWORK_COLUMNS } from './redesign/surveyMetrics';
import { canSetStatus, marketsNotReadyForLive, liveUrlMessage } from './redesign/statusGuard';

const MODAL_TYPES = {
    NONE: 'NONE',
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    DETAILS: 'DETAILS',
};

// PM Dashboard status cards deep-link here as ?surveyType=<status>.
// Whitelisted to the 5 known values; anything else is treated as no filter.
const readSurveyTypeFromUrl = (search: string): string => {
    const allowed = ['Open', 'Hold', 'Test', 'Wait', 'Close'];
    const params = new URLSearchParams(search || '');
    const value = params.get('surveyType') || '';
    return allowed.includes(value) ? value : '';
};

type State = {
    status: PageStatus,
    error: string | null,
    formType: string,
    data: any[],
    id?: string | null,
    filteredData: any[],
    // Same filter fields and params as the production Surveys list.
    filters: {
        dateRange: any,
        projectId: '',
        client: '',
        publishDate: '',
        expiryDate: '',
        surveyName: '',
        surveyType: '',
        projectname: '',
        country: '',
        pmName: '',
    },
    pageSize: any,
    currentPageNumber: any,
    loading: any,
    survey_unique_id: string,
    pmRespoOptions: any[],
    countryOpts: any[],
    expandedParents: any,
};

class DashboardSurveyComponent extends Component<any, any> {
    static contextType = LanguageContext;
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            status: PageStatus.None,
            error: null,
            // All fieldwork is the first-time default; a remembered Summary pick is kept.
            columnSet: (() => { try { return localStorage.getItem('dx.surveys.columns') === 'summary' ? 'summary' : 'all'; } catch { return 'all'; } })(),
            formType: MODAL_TYPES.NONE,
            data: [],
            id: null,
            filteredData: [],
            filters: {
                dateRange: '',
                projectId: '',
                client: '',
                publishDate: '',
                expiryDate: '',
                surveyName: '',
                surveyType: readSurveyTypeFromUrl(props.location && props.location.search),
                projectname: '',
                country: '',
                pmName: '',
            },
            pageSize: 10,
            currentPageNumber: 1,
            totalResponseData: '',
            totalResponsePages: '',
            loading: false,
            survey_unique_id: '',
            pmRespoOptions: [],
            countryOpts: [],
            expandedParents: {},
        };
        this.fetchList = this.fetchList.bind(this);
    }

    toggleParent = (parentId: string) => {
        this.setState((prev) => ({
            expandedParents: {
                ...prev.expandedParents,
                [parentId]: !prev.expandedParents[parentId],
            },
        }));
    };

    componentDidMount() {
        this._isMounted = true;
        const hash = window.location.hash || '';
        const queryIdx = hash.indexOf('?');
        const queryStr = queryIdx !== -1 ? hash.substring(queryIdx + 1) : window.location.search.substring(1);
        const urlParams = new URLSearchParams(queryStr);
        const detailsId = urlParams.get('detailsId');
        if (detailsId) {
            this.props.history.replace(`/${this.props.role || 'admin'}/surveys/details/${detailsId}`);
            return;
        }
        this.fetchList();
        this.fetchPmList();
        this.fetchCountryList();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    fetchPmList(): Promise<void> {
        return Promise.resolve()
            .then(() => { if (this._isMounted) this.setState({ status: PageStatus.Loading }) })
            .then(() => SurveysAPI.pmListAPI())
            .then((response) => {
                if (!this._isMounted) return;
                let pmRespo: any = response;
                let pmData = pmRespo.map((ele: any) => {
                    let value = "";
                    if (ele.basic_profile.firstName) {
                        value += ele.basic_profile.firstName += ele.basic_profile.lastName ? " " : "";
                    }
                    if (ele.basic_profile.lastName) {
                        value += ele.basic_profile.lastName;
                    }
                    return { label: value, value }
                });
                this.setState({ pmRespoOptions: pmData, status: PageStatus.Loaded });
            })
            .catch((error) => {
                if (this._isMounted) this.setState({ error: error.message, status: PageStatus.Error });
            });
    }

    fetchCountryList(): Promise<void> {
        return Promise.resolve()
            .then(() => MasterDataAPI.countryList('10000'))
            .then((countries: any) => {
                if (!this._isMounted) return;
                const options = countries.map(country => ({
                    label: country.name,
                    value: country.name,
                }));
                this.setState({ countryOpts: options });
            })
            .catch(err => console.error("Failed to fetch country list", err));
    }

    fetchList(silent = false): Promise<void> {
        return Promise.resolve()
            .then(() => { if (this._isMounted && !silent) this.setState({ status: PageStatus.Loading }) })
            .then(() => SurveysAPI.getAll(this.state.pageSize, this.state.currentPageNumber, this.state.filters))
            .then((surveyData) => {
                if (!this._isMounted) return;
                let surveyRespoData: any = surveyData;
                this.setState({ data: surveyRespoData.data, filteredData: surveyRespoData.data, totalResponseData: surveyRespoData.totalCount, totalResponsePages: surveyRespoData.totalPage, status: PageStatus.Loaded });
            })
            .catch((error) => {
                if (this._isMounted) this.setState({ error: error.message, status: PageStatus.Error });
            });
    }


    handleFilterChange = (e) => {
        const { name, value } = e.target;
        this.setState(
            (prevState) => ({
                filters: {
                    ...prevState.filters,
                    [name]: value,
                },
            }),
        );
    };

    applyFilters = () => {
        const { publishDate, expiryDate } = this.state.filters;
        if (publishDate && expiryDate && new Date(expiryDate) < new Date(publishDate)) {
            Swal.fire({ icon: 'warning', title: 'Invalid Date Range', text: 'End date must be after start date.' });
            return;
        }
        if (this.state.currentPageNumber == 1) { this.fetchList(); return; }
        this.setState({ currentPageNumber: 1 });
    };

    setColumnSet = (columnSet: 'summary' | 'all') => {
        this.setState({ columnSet });
        try { localStorage.setItem('dx.surveys.columns', columnSet); } catch { /* storage unavailable */ }
    };

    clearFilter = async () => {
        await new Promise((resolve: any) =>
            this.setState({
                filters: {
                    client: '',
                    publishDate: '',
                    projectId: '',
                    expiryDate: '',
                    surveyName: '',
                    surveyType: '',
                    dateRange: '',
                    projectname: '',
                    country: '',
                    pmName: '',
                },
                pageSize: 10,
                currentPageNumber: 1,
                totalResponseData: '',
                totalResponsePages: ''
            }, resolve))
        this.fetchList();
    }

    async handleExport() {
        const { currentPageNumber, filters } = this.state;
        this.setState({ loading: true });
        try {
            const recievedData = await SurveysAPI.getAll('All', currentPageNumber, filters);
            if (this._isMounted) exportToExcel(recievedData.data, 'surveys');
        } catch (error) {
            console.error("Error exporting data:", error);
        } finally {
            if (this._isMounted) this.setState({ loading: false });
        }
    };
    handlePageSizeChange = (newValue: any) => { this.setState({ pageSize: newValue, currentPageNumber: 1 }); };
    handlePageNumberChange = (newValue: any) => { this.setState({ currentPageNumber: newValue }); };

    componentDidUpdate(prevProps: any, prevState: State) {
        if (prevState.pageSize !== this.state.pageSize || prevState.currentPageNumber !== this.state.currentPageNumber) { this.fetchList(); }
        if (prevProps.selectedCountry !== this.props.selectedCountry) {
            this.setState({ currentPageNumber: 1 }, () => this.fetchList());
        }
        // A PM Dashboard card clicked while already on /surveys changes only the
        // query string, so the component is not remounted. Re-apply the filter.
        if (prevProps.location && this.props.location &&
            prevProps.location.search !== this.props.location.search) {
            const surveyType = readSurveyTypeFromUrl(this.props.location.search);
            this.setState(
                (prev) => ({
                    filters: { ...prev.filters, surveyType },
                    currentPageNumber: 1,
                }),
                () => this.fetchList()
            );
        }
    }

    handleStatusChangeFunc = async (e, id, survayEndDate) => {
        this.setState({ loading: true });
        try {
            if (!canSetStatus(survayEndDate, e.target.value)) { return; }
            if (e.target.value === 'Open') {
                // Live needs a Live URL on every market. The paginated list rows
                // may not carry url/useUniqueLinks; when they don't, the check is
                // skipped here and the backend guard rejects with the same message.
                const rows: any[] = this.state.filteredData || [];
                const row = rows.find((r: any) => r.id === id);
                if (row && Object.prototype.hasOwnProperty.call(row, 'url')) {
                    const parentRow = row.parentid ? rows.find((r: any) => r.id === row.parentid) : null;
                    const kids = row.parentid ? [] : (groupSurveysByParent(rows).find((g: any) => g.id === id)?.children || []);
                    const notReady = marketsNotReadyForLive(row, parentRow, kids);
                    if (notReady.length > 0) {
                        Swal.fire({ icon: 'warning', title: 'Live URL missing', text: liveUrlMessage(notReady) });
                        return;
                    }
                }
            }
            let payload = { surveyId: id, status: e.target.value }
            await SurveysAPI.updateSurveyStatusOnly(payload);
            if (this._isMounted) await this.fetchList();
        } catch (error) {
            console.error("Status change error:", error);
            const serverMessage = error?.response?.data?.message || error?.message;
            if (serverMessage) { Swal.fire({ icon: 'warning', title: 'Status not changed', text: String(serverMessage) }); }
            if (this._isMounted) await this.fetchList();
        } finally {
            if (this._isMounted) this.setState({ loading: false });
        }
    }

    render() {
        const { filters, pageSize, currentPageNumber, totalResponseData, totalResponsePages } = this.state;
        const lang = this.context || 'en';
        const t = (key) => (pageDict[lang] && pageDict[lang][key]) || pageDict['en'][key] || key;
        // Sales is read-only: no Create, and the row status is plain text instead of the inline select.
        const isSales = this.props.role === 'sales';
        const canSetError = this.props.role === 'admin' || this.props.role === 'super_admin';
        const showAll = this.state.columnSet === 'all';
        const surveyStatusLabel = (type) => {
            const labels = {
                Test: 'Test',
                Hold: 'On Hold',
                Open: 'Live',
                Wait: 'Ids awaited',
                Close: 'End',
                Error: 'Error',
            };
            return labels[type] ?? (type || '-');
        };
        const dropoutCalculationFunc = (totDropout, totHits) => {
            let calculatedValue = 0;
            if (totHits == 0) { return calculatedValue; }
            if (!isNaN(Number(totDropout)) && !isNaN(Number(totHits)))
                calculatedValue = ((Number(totDropout) / Number(totHits)) * 100).toFixed(2);
            return calculatedValue;
        }
        const aggregateChildrenStats = (children = [], parentRow: any = null) => {
            const sum = (key) => (Number(parentRow?.[key]) || 0) + children.reduce((a, c) => a + (Number(c?.[key]) || 0), 0);
            const completed_count = sum('completed_count');
            const terminated_count = sum('terminated_count');
            const over_quota_count = sum('over_quota_count');
            // PQ-split: quality_terminated_count is now post-survey QT (isPreScreenTerminated
            // IS NOT TRUE); pq_terminated_count is prescreener-fail QT (= TRUE). The two
            // children-sum keys exist on every child row returned by getAll's split queries.
            const quality_terminated_count = sum('quality_terminated_count');
            const pq_terminated_count = sum('pq_terminated_count');
            const verisoul_terminate_count = sum('verisoul_terminate_count');
            const totalhit_count = sum('totalhit_count');
            const dropout_count = sum('dropout_count');
            // Median LOI: completes-weighted average across parent + children (approximation)
            const parentCompletes = Number(parentRow?.completed_count) || 0;
            const parentLoiSum = parentCompletes * (Number(parentRow?.finalLOI) || 0);
            const childrenLoiSum = children.reduce(
                (a, c) => a + ((Number(c?.finalLOI) || 0) * (Number(c?.completed_count) || 0)),
                0
            );
            const finalLOI = completed_count > 0
                ? (parentLoiSum + childrenLoiSum) / completed_count
                : 0;
            return {
                completed_count,
                terminated_count,
                over_quota_count,
                quality_terminated_count,
                pq_terminated_count,
                verisoul_terminate_count,
                totalhit_count,
                dropout_count,
                finalLOI,
            };
        };
        type RowCtx = { survey: any; stats: any; isChild: boolean; parent: any };
        const columnMap: Record<string, { th: React.ReactNode; td: (ctx: RowCtx) => React.ReactNode }> = {
            'Project Name': {
                th: t("Project Name"),
                td: ({ survey, isChild, parent }) => (
                    <td className="text-start" style={isChild ? { paddingLeft: '36px' } : {}}>
                        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                            {!isChild && parent.hasChildren ? (
                                <span onClick={() => this.toggleParent(parent.id)} style={{ cursor: 'pointer', marginRight: '6px', display: 'inline-block', transition: 'transform 0.2s', transform: this.state.expandedParents[parent.id] ? 'rotate(90deg)' : 'rotate(0deg)', flexShrink: 0, marginTop: '2px' }}>&#9654;</span>
                            ) : isChild ? (
                                <span style={{ color: '#999', marginRight: '6px', flexShrink: 0 }}>&#9492;</span>
                            ) : (
                                <span style={{ display: 'inline-block', width: '16px', flexShrink: 0 }}></span>
                            )}
                            <a
                                href={`#/${this.props.role || 'admin'}/surveys/details/${survey.id}`}
                                // Detail pages open in their own tab so the filtered list stays put.
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-primary text-start d-block"
                                style={{ textDecoration: 'none', whiteSpace: "normal", ...(isChild ? { fontSize: '0.92em' } : {}) }}
                            >
                                <div
                                    style={{ textAlign: "left", display: "block", whiteSpace: "normal" }}
                                    dangerouslySetInnerHTML={{
                                        // One expression for both branches: getSurveyDisplayName
                                        // keys on the row's own parentid, so it covers children,
                                        // parents, and orphan children alike. `isChild` below is
                                        // still used for row styling/indent only.
                                        __html: getSurveyDisplayName(survey) || "Title",
                                    }}
                                ></div>
                            </a>
                        </div>
                    </td>
                ),
            },
            'Project Id': { th: t("Project Id"), td: ({ survey }) => <td>{survey?.projectId ?? "-"}</td> },
            'Country': {
                th: t("Country"),
                td: ({ survey, isChild, parent }) => <td>{!isChild && parent.hasChildren ? marketCodes(parent) : (survey?.country ?? "-")}</td>,
            },
            'Survey Unique Id': { th: t("Survey Unique Id"), td: ({ survey }) => <td>{survey?.uniqueid ?? "-"}</td> },
            'Client': { th: t("Client"), td: ({ survey }) => <td>{survey.client}</td> },
            'Status': {
                th: <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{t("Status")}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>,
                td: ({ survey }) => (
                    <td>{isSales ? surveyStatusLabel(survey.surveyType) : (<div className="">
                        <select
                            className="dx-plain-select"
                            name='surveyType'
                            id='type'
                            required
                            value={survey.surveyType}
                            onChange={(e) => this.handleStatusChangeFunc(e, survey.id, survey.expiryDate)}
                        >
                            <option value='' disabled>--Choose--</option>
                            <option value='Test'>Test</option>
                            <option value='Hold'>On Hold</option>
                            <option value='Open'>Live</option>
                            <option value='Wait'>Ids awaited </option>
                            <option value='Close'>End</option>
                            {/* Only admin/super_admin may set Error (backend enforces the same). */}
                            <option value='Error' disabled={!canSetError}>Error</option>
                        </select>
                    </div>)}</td>
                ),
            },
            'PM': { th: t("PM"), td: ({ survey }) => <td>{survey.pmName}</td> },
            'Client Quota': { th: t("Client Quota"), td: ({ survey }) => <td>{survey.userLimitCommitted ?? "-"}</td> },
            'Complete': {
                th: t("Complete"),
                td: ({ survey, stats }) => {
                    // Summary adds a thin progress bar under the count; All fieldwork stays a plain number.
                    const quota = Number(survey.userLimitCommitted);
                    const showBar = !showAll && Number.isFinite(quota) && quota > 0;
                    const pct = showBar ? Math.min(100, ((Number(stats.completed_count) || 0) / quota) * 100) : 0;
                    return (
                        <td>
                            {stats.completed_count}
                            {showBar && (
                                <div className="progress dx-complete-bar" data-testid="complete-bar">
                                    <div className="progress-bar" style={{ width: `${pct}%` }}></div>
                                </div>
                            )}
                        </td>
                    );
                },
            },
            'Terminate': { th: t("Terminate"), td: ({ stats }) => <td>{stats.terminated_count}</td> },
            'Quotafull': { th: t("Quotafull"), td: ({ stats }) => <td>{stats.over_quota_count}</td> },
            'Quality Terminate': { th: t("Quality Terminate"), td: ({ stats }) => <td>{stats.quality_terminated_count}</td> },
            'PQ Terminated': { th: t("PQ Terminated"), td: ({ stats }) => <td>{stats.pq_terminated_count ?? 0}</td> },
            'Verisoul Blocked': { th: t("Verisoul Blocked"), td: ({ stats }) => <td>{stats.verisoul_terminate_count ?? 0}</td> },
            'Hits': { th: t("Hits"), td: ({ stats }) => <td>{stats.totalhit_count}</td> },
            'Dropouts%': { th: t("Dropouts%"), td: ({ stats }) => <td>{dropoutCalculationFunc(stats.dropout_count, stats.totalhit_count)}</td> },
            'IR %': {
                th: t("IR %"),
                td: ({ stats }) => (
                    <td>
                        {Number(stats.completed_count) + Number(stats.terminated_count) > 0
                            ? ((Number(stats.completed_count) / (Number(stats.completed_count) + Number(stats.terminated_count))) * 100).toFixed(2)
                            : '0.00'
                        }
                    </td>
                ),
            },
            'Median LOI': {
                th: t("Median LOI"),
                td: ({ stats }) => (
                    <td>
                        {!isNaN(stats.finalLOI) && stats.finalLOI !== null ? Number(stats.finalLOI).toFixed(2) : '0.00'}
                    </td>
                ),
            },
            'Complete Points': {
                th: t("Complete Points"),
                td: ({ survey }) => <td>{isPanelCountryByName(survey.country) ? survey.ceggPoints : '-'}</td>,
            },
            'Start Date': { th: t("Start Date"), td: ({ survey }) => <td>{moment(survey.publishDate).format('MM/DD/YYYY')}</td> },
            'End Date': {
                th: t("End Date"),
                td: ({ survey }) => <td>{survey.expiryDate ? moment(survey.expiryDate).format('MM/DD/YYYY') : '-'}</td>,
            },
        };
        const activeColumns = showAll ? ALL_FIELDWORK_COLUMNS : SUMMARY_COLUMNS;
        return (
            <div className="dx-surveys">
                <GridContainer>
                    <div className='w-100 mb-3'>
                        <CardHeader color="primary">
                            <div className="d-flex align-items-center justify-content-between">
                                <h4>{t("Surveys")}</h4>
                                {!isSales && (
                                <div>
                                    <Button
                                        onClick={() => this.props.history.push(`/${this.props.role || 'admin'}/surveys/new`)}
                                        variant="primary"
                                        size="sm"
                                        className="mx-1"
                                    >
                                        <FontAwesomeIcon icon={['fas', 'plus']} className="mr-2" />
                                        {t("Create")}
                                    </Button>
                                </div>
                                )}
                            </div>
                        </CardHeader>
                    </div>
                </GridContainer>

                {/* Filter card copied from the production Surveys list (Surveys.tsx on
                    release/26-08-2026): same fields, order and buttons. It applies only on
                    Filter Surveys. */}
                <div className="jumbotron bg-white p-3 border shadow-sm">
                    <div className='mb-3'>{t("Filter")}</div>
                    <form>
                        <div className="row">
                            <div className="col">
                                <label htmlFor='publishDate'>{t("Start Date")}</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    placeholder="select date"
                                    name="publishDate"
                                    value={filters.publishDate}
                                    onChange={this.handleFilterChange}

                                />
                            </div>
                            <div className="col">
                                <label htmlFor='pmName'>{t("PM Name")}</label>
                                <select
                                    className="dx-plain-select"
                                    name='pmName'
                                    id='pmName'
                                    value={filters.pmName}
                                    onChange={this.handleFilterChange}
                                >
                                    <option value=''>{t("--Choose--")}</option>
                                    {this.state.pmRespoOptions.length > 0 ? this.state.pmRespoOptions.map((item, index) => (
                                        <option key={"pmRespoOptions" + index} value={item.label}>{item.label}</option>
                                    )) : ''}
                                </select>
                            </div>
                            <div className="col">
                                <label htmlFor='expiryDate'>{t("End Date")}</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    placeholder="select date"
                                    name="expiryDate"
                                    value={filters.expiryDate}
                                    min={filters.publishDate || undefined}
                                    onChange={this.handleFilterChange}
                                />
                            </div>
                            <div className="col">
                                <label htmlFor='surveyType'>{t("Type")}</label>
                                <select
                                    className="dx-plain-select"
                                    name='surveyType'
                                    id='type'
                                    required
                                    value={filters.surveyType}
                                    onChange={this.handleFilterChange}
                                >
                                    <option value='' disabled>{t("--Choose--")}</option>
                                    <option value='Test'>{t("Test")}</option>
                                    <option value='Hold'>{t("On Hold")}</option>
                                    <option value='Open'>{t("Live")}</option>
                                    <option value='Wait'>{t("Ids awaited")}</option>
                                    <option value='Close'>{t("End")}</option>
                                </select>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <label htmlFor='projectname'>{t("Project Name")}</label>
                                <input type="text"
                                    className="form-control"
                                    placeholder={t("Enter...")}
                                    name="projectname"
                                    value={filters.projectname}
                                    onChange={this.handleFilterChange}
                                />
                            </div>
                            <div className="col">
                                <label htmlFor='projectId'>{t("Project ID")}</label>
                                <input type="text"
                                    className="form-control"
                                    placeholder={t("Enter...")}
                                    name="projectId"
                                    value={filters.projectId}
                                    onChange={this.handleFilterChange}
                                />
                            </div>
                            <div className="col">
                                <label htmlFor='client'>{t("Client Name")}</label>
                                <input type="text" name="client" className="form-control" placeholder={t("Enter...")} value={filters.client}
                                    onChange={this.handleFilterChange} />
                            </div>
                            <div className="col">
                                <label htmlFor='country'>{t("Country")}</label>
                                <select
                                    className="dx-plain-select"
                                    name='country'
                                    id='country'
                                    value={filters.country}
                                    onChange={this.handleFilterChange}
                                >
                                    <option value=''>{t("--Choose--")}</option>
                                    {this.state.countryOpts && this.state.countryOpts.length > 0 ? this.state.countryOpts.map((item, index) => (
                                        <option key={"countryOpts" + index} value={item.value}>{item.label}</option>
                                    )) : ''}
                                </select>
                            </div>
                        </div>
                    </form>

                    <div className="jumbotron bg-white p-1 mt-2 shadow-sm">
                        <button type="button" className="btn btn-success" onClick={() => this.applyFilters()}>{t("Filter Surveys")}</button>
                        <button type="button" className="btn btn-info ml-1" onClick={() => this.handleExport()}>{t("Export")}</button>
                        <button type="button" className="btn btn-danger ml-1" onClick={() => this.clearFilter()}>{t("Clear Filter")}</button>
                    </div>


                </div>

                <div className="dx-card">
                    <Alert variant="danger" show={this.state.status === PageStatus.Error}>
                        {this.state.error}
                    </Alert>

                    <Show when={this.state.status === PageStatus.Loading}>
                        <div className="d-flex justify-content-center w-100 p-5">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    </Show>

                    <Show when={this.state.status === PageStatus.Loaded}>
                        <Show when={!this.state.filteredData.length}>
                            <Alert variant="info" show={!this.state.filteredData.length}>
                                {t("No data is available")}
                            </Alert>
                        </Show>

                        <Show when={!!this.state.filteredData.length}>
                            {(
                                <>
                            <div className='mb-2 d-flex align-items-center'>
                                <ShowDataAccording2PageSize
                                    currentPageSize={pageSize}
                                    currentPage={currentPageNumber}
                                    sendPageSize={this.handlePageSizeChange}
                                    showTotalData={totalResponseData}
                                    sendLastPage={totalResponsePages}
                                />
                                <div className="btn-group btn-group-sm ml-3" role="group" aria-label={t("Columns")}>
                                    <button type="button" className={`btn ${this.state.columnSet === 'summary' ? 'btn-dark' : 'btn-outline-dark'}`} onClick={() => this.setColumnSet('summary')}>{t("Summary")}</button>
                                    <button type="button" className={`btn ${this.state.columnSet === 'all' ? 'btn-dark' : 'btn-outline-dark'}`} onClick={() => this.setColumnSet('all')}>{t("All fieldwork")}</button>
                                </div>
                            </div>
                            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: '9999' }}>
                                {this.state.loading && (
                                    <img style={{ height: "415px", }}
                                        src="../loadernew.gif"
                                        alt="Loading..."
                                    />
                                )}
                            </div>
                            <Table responsive size="sm" bordered className="dx-table">
                                <thead>
                                    <tr>
                                        {activeColumns.map((label) => (
                                            <th key={label}>{columnMap[label].th}</th>
                                        ))}
                                    </tr>
                                </thead>

                                <tbody>
                                    {
                                        groupSurveysByParent(this.state.filteredData).map((parent) => {
                                        const parentAggregates = parent.hasChildren ? aggregateChildrenStats(parent.children, parent) : null;
                                        const renderRow = (survey, isChild = false) => {
                                        const useAggregates = !isChild && parent.hasChildren && parentAggregates;
                                        const stats = useAggregates ? parentAggregates : survey;
                                        const ctx = { survey, stats, isChild, parent };
                                        return (
                                            <tr key={survey.id} style={isChild ? { backgroundColor: '#f0f4f8' } : (parent.hasChildren ? { backgroundColor: '#f8f9fa' } : {})}>
                                                {activeColumns.map((label) => (
                                                    <Fragment key={label}>{columnMap[label].td(ctx)}</Fragment>
                                                ))}
                                            </tr>
                                        );
                                        };
                                        return (
                                            <Fragment key={parent.id}>
                                                {renderRow(parent)}
                                                {this.state.expandedParents[parent.id] && parent.children.map((child) => renderRow(child, true))}
                                            </Fragment>
                                        );})
                                    }
                                </tbody>
                            </Table>
                            <div>
                                <PaginationNumbering
                                    currentPage={currentPageNumber}
                                    returnPagenumber={this.handlePageNumberChange}
                                    showTotalData={totalResponseData}
                                    sendLastPage={totalResponsePages}
                                />
                            </div>
                            </>
                            )}
                        </Show>
                    </Show>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    selectedCountry: state.adminUser.adminUser.selectedCountry,
    role: state.adminUser?.adminUser?.role,
});

const DashboardSurvey = connect(mapStateToProps)(DashboardSurveyComponent);
export { DashboardSurvey };
